/* tslint:disable */
/* eslint-disable */
/**
 * wicky_ups
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../Components/api/runtime';
import {
    ChunkedListBase,
    ChunkedListBaseFromJSON,
    ChunkedListBaseFromJSONTyped,
    ChunkedListBaseToJSON,
    DeviceInfo,
    DeviceInfoFromJSON,
    DeviceInfoFromJSONTyped,
    DeviceInfoToJSON,
    DeviceInfoListChunkAllOf,
    DeviceInfoListChunkAllOfFromJSON,
    DeviceInfoListChunkAllOfFromJSONTyped,
    DeviceInfoListChunkAllOfToJSON,
} from './';

/**
 * 
 * @export
 * @interface DeviceInfoListChunk
 */
export interface DeviceInfoListChunk {
    /**
     * 
     * @type {number}
     * @memberof DeviceInfoListChunk
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceInfoListChunk
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceInfoListChunk
     */
    totalCount: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceInfoListChunk
     */
    pageCount: number;
    /**
     * 
     * @type {Array<DeviceInfo>}
     * @memberof DeviceInfoListChunk
     */
    chunk: Array<DeviceInfo>;
}

export function DeviceInfoListChunkFromJSON(json: any): DeviceInfoListChunk {
    return DeviceInfoListChunkFromJSONTyped(json, false);
}

export function DeviceInfoListChunkFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceInfoListChunk {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'size': json['size'],
        'totalCount': json['totalCount'],
        'pageCount': json['pageCount'],
        'chunk': ((json['chunk'] as Array<any>).map(DeviceInfoFromJSON)),
    };
}

export function DeviceInfoListChunkToJSON(value?: DeviceInfoListChunk | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'size': value.size,
        'totalCount': value.totalCount,
        'pageCount': value.pageCount,
        'chunk': ((value.chunk as Array<any>).map(DeviceInfoToJSON)),
    };
}


